import { PointRecipientDto, PointStatusDto } from '@shared/interfaces/dtos/points';
import { StateDto } from '../types/dtos';
import { PointState } from '../types/points';
import { PointAction, PointRecipient, PointStatus } from '@shared/interfaces/points';
import { ScheduleUtil } from './schedule.util';

export abstract class PointsMapper {
  private static determinePointActionRecipientKind(recipient: PointRecipientDto): 'user' | 'service' | 'group' {
    if (recipient.contactIdiAdmin || recipient.contactId) {
      return 'user';
    } else if (recipient.serviceId) {
      return 'service';
    } else if (recipient.groupeId) {
      return 'group';
    }

    return 'user';
  }
  private static toStatus(status: PointStatusDto): PointStatus {
    return {
      id: status.id,
      label: status.description,
      active: status.utilisable,
    };
  }

  public static toState(state: StateDto): PointState {
    switch (state) {
      case 'Ouvert':
        return 'open';
      case 'Ferme':
        return 'closed';
      case 'Verrouille':
        return 'locked';
      default:
        throw new Error(`Invalid status: ${state}`);
    }
  }

  public static toPointAction(dto: PointRecipientDto, pointId: number): PointAction {
    const recipientKind = PointsMapper.determinePointActionRecipientKind(dto);

    return {
      scope: 'points',
      id: dto.id,
      pointId,
      type: dto.traiteLe ? 'done' : 'to-do',
      mailId: dto.mailId,
      demander: {
        id: dto.transmissionUserId,
        fromIadmin: true,
        kind: 'user',
      },
      recipient: {
        id:
          PointsMapper.determinePointActionRecipientKind(dto) === 'user'
            ? (dto.contactIdiAdmin ?? dto.contactId)
            : PointsMapper.determinePointActionRecipientKind(dto) === 'service'
              ? dto.serviceId
              : dto.groupeId,
        fromIadmin: recipientKind === 'user',
        kind: recipientKind,
      },
      purpose: dto.action,
      subject: '',
      done: !!dto.traiteLe,
      doneAt: dto.traiteLe ? new Date(dto.traiteLe) : null,
      createdAt: new Date(dto.transmisDate!),
      delayedAnnouncement: ScheduleUtil.delaySinceToday(new Date(dto.transmisDate!)),
      status: dto.statut ?? null,
      deadline: dto.echeance ? new Date(dto.echeance) : null,
      message: dto.message,
      answer: dto.reponse,
      serviceId: dto.serviceId,
      groupId: dto.groupeId,
      processable: dto.rights.canReply,
    };
  }

  public static toPointRecipient(dto: PointRecipientDto): PointRecipient {
    const recipientKind = PointsMapper.determinePointActionRecipientKind(dto);

    return {
      demander: {
        id: dto.transmissionUserId,
        fromIadmin: true,
        kind: 'user',
      },
      recipient: {
        id: (PointsMapper.determinePointActionRecipientKind(dto) === 'user'
          ? dto.contactIdiAdmin /*?? dto.contactId*/ // There is a difference between a contactIdAdmin and a contactId
          : PointsMapper.determinePointActionRecipientKind(dto) === 'service'
            ? dto.serviceId
            : dto.groupeId) as number,
        fromIadmin: recipientKind === 'user',
        kind: recipientKind,
        detailId: dto.id,
      },
      message: dto.message ?? null,
      mainRecipient: dto.principal ?? false,
      createdAt: new Date(dto.transmisDate!),
    };
  }
}
